import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "style", "title", "children", "visible", "color", "disabled", "bordered", "closable", "light", "onClose"];
import React from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function (props) {
  if (props === void 0) {
    props = {};
  }
  var {
      prefixCls = 'w-tag',
      className,
      style,
      title = '',
      children,
      visible = true,
      color = '#6E6E6E',
      disabled = false,
      bordered = true,
      closable,
      light = false,
      onClose
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className, light ? prefixCls + "-light" : null, disabled ? 'disabled' : null].filter(Boolean).join(' ').trim();
  var styl = _extends({}, style);
  if (!light) {
    styl.color = '#fff';
    styl.backgroundColor = color;
  } else {
    styl.color = color;
    styl.borderColor = color;
    if (bordered && light) {
      styl.boxShadow = "inset 0 0 0 1px " + color;
    }
  }
  if (!visible) {
    return null;
  }
  var iconClose = !disabled && closable && /*#__PURE__*/_jsx("svg", {
    onClick: onClose,
    className: prefixCls + "-close",
    width: "15",
    height: "15",
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z"
    })
  });
  return /*#__PURE__*/_jsxs("span", _extends({
    className: cls,
    style: styl
  }, other, {
    children: [title || children, iconClose]
  }));
});